(function () {
    "use strict";

    document.addEventListener("DOMContentLoaded", function () {
        var headings = document.querySelectorAll(".top-footer__name");
        var breakpoint = 768;

        /**
         * Setup menu styles for mobile accordion mode
         */
        function enableAccordion() {
            headings.forEach(function (heading) {
                var cell = heading.closest(".top-footer__cell");
                var menu = cell ? cell.querySelector(".top-footer__wrap--menu") : null;

                if (!menu) {
                    return;
                }

                menu.style.overflow = "hidden";
                menu.style.transition = "max-height 0.2s ease";

                if (cell.classList.contains("is-open")) {
                    menu.style.maxHeight = menu.scrollHeight + "px";
                } else {
                    menu.style.maxHeight = "0";
                }
            });
        }

        /**
         * Reset menu styles for desktop mode
         */
        function disableAccordion() {
            headings.forEach(function (heading) {
                var cell = heading.closest(".top-footer__cell");
                var menu = cell ? cell.querySelector(".top-footer__wrap--menu") : null;

                if (!menu) {
                    return;
                }

                cell.classList.remove("is-open");
                menu.style.overflow = "";
                menu.style.transition = "";
                menu.style.maxHeight = "";
            });
        }

        /**
         * Apply correct mode based on window width
         */
        function handleFooterMenus() {
            if (window.innerWidth >= breakpoint) {
                disableAccordion();
            } else {
                enableAccordion();
            }
        }

        headings.forEach(function (heading) {
            heading.addEventListener("click", function () {
                if (window.innerWidth >= breakpoint) {
                    return;
                }

                var cell = heading.closest(".top-footer__cell");
                var menu = cell ? cell.querySelector(".top-footer__wrap--menu") : null;

                if (!menu) {
                    return;
                }

                if (cell.classList.contains("is-open")) {
                    menu.style.maxHeight = "0";
                    cell.classList.remove("is-open");
                } else {
                    menu.style.maxHeight = menu.scrollHeight + "px";
                    cell.classList.add("is-open");
                }
            });
        });

        handleFooterMenus();
        window.addEventListener("resize", handleFooterMenus);
    });
})();